export default __webpack_public_path__ + "static/media/text3.628bd1df.glb";